var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useState, useRef, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Alert, Box, Button, Card, CardContent, TextField, Typography, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { trusteeFilename } from "@/services/trusteeFilename";
import { AuthContext } from "@/providers/AuthContextProvider";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { createBrowserTrustee, loadBrowserTrustee, listBrowserTrusteeBoards, runBrowserCycle, runExclusiveBrowserTrustee, } from "@/services/BrowserTrustee";
var actionGrid = {
    "display": "grid",
    "gridTemplateColumns": {
        xs: "1fr",
        sm: "repeat(2, minmax(0, 1fr))",
        lg: "repeat(3, minmax(0, 1fr))",
    },
    "gap": 1.5,
    "& .MuiButton-root": { minHeight: 44 },
};
var codeExample = {
    my: 2,
    p: 2,
    bgcolor: "action.hover",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    fontFamily: "monospace",
    fontSize: "0.875rem",
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
};
export var TrusteeDashboard = function () {
    var auth = useContext(AuthContext);
    // The in-memory token Keycloak keeps fresh, as for every portal request.
    var accessToken = function () { var _a; return (_a = auth.getAccessToken()) !== null && _a !== void 0 ? _a : ""; };
    var globalSettings = useContext(SettingsContext).globalSettings;
    var platform = globalSettings.HASURA_URL;
    var trustee = auth.trustee || auth.username;
    var keysFilename = trusteeFilename(trustee, "private-keys.toml");
    var requestFilename = trusteeFilename(trustee, "custody.json");
    var proofFilename = trusteeFilename(trustee, "signed-custody-proof.json");
    var _a = useState([]), boards = _a[0], setBoards = _a[1];
    var _b = useState(""), error = _b[0], setError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), loaded = _d[0], setLoaded = _d[1];
    var refresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, assigned_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    token = accessToken();
                    if (!token)
                        throw new Error("Sign in as a trustee to list assigned boards.");
                    return [4 /*yield*/, listBrowserTrusteeBoards(platform, token)];
                case 2:
                    assigned_1 = _a.sent();
                    setBoards(assigned_1);
                    setLoaded(true);
                    if (!(engine.current && !active.current)) return [3 /*break*/, 4];
                    return [4 /*yield*/, perform(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, readHistory(engine.current, assigned_1)];
                        }); }); })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    error_1 = _a.sent();
                    setError(error_1 instanceof Error ? error_1.message : String(error_1));
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var _e = useState(globalSettings.WBRAID_BOARD_URL || "/b4"), boardUrl = _e[0], setBoardUrl = _e[1];
    var _f = useState(null), keys = _f[0], setKeys = _f[1];
    var _g = useState(null), history = _g[0], setHistory = _g[1];
    var _h = useState(""), historyError = _h[0], setHistoryError = _h[1];
    var _j = useState(false), running = _j[0], setRunning = _j[1];
    var _k = useState(false), busy = _k[0], setBusy = _k[1];
    var _l = useState(""), browserStatus = _l[0], setBrowserStatus = _l[1];
    var _m = useState(""), tallyId = _m[0], setTallyId = _m[1];
    var keysInput = useRef(null);
    var backupInput = useRef(null);
    var custodyInput = useRef(null);
    var engine = useRef(null);
    var privateKeys = useRef("");
    var active = useRef(false);
    var occupied = useRef(false);
    var mounted = useRef(true);
    var timer = useRef(undefined);
    var catalog = useRef([]);
    var catalogKey = useRef("");
    var releaseLock = useRef(null);
    var release = function () {
        var _a;
        (_a = releaseLock.current) === null || _a === void 0 ? void 0 : _a.call(releaseLock);
        releaseLock.current = null;
    };
    useEffect(function () {
        mounted.current = true;
        return function () {
            var _a;
            mounted.current = false;
            active.current = false;
            clearTimeout(timer.current);
            if (!occupied.current) {
                (_a = engine.current) === null || _a === void 0 ? void 0 : _a.free();
                engine.current = null;
                release();
            }
        };
    }, []);
    var download = function (name, contents, type) {
        var url = URL.createObjectURL(new Blob([contents], { type: type }));
        var anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = trusteeFilename(trustee, name);
        anchor.click();
        setTimeout(function () { return URL.revokeObjectURL(url); }, 0);
    };
    var perform = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (occupied.current)
                        return [2 /*return*/];
                    occupied.current = true;
                    setBusy(true);
                    setError("");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, action()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    if (mounted.current)
                        setError(error_2 instanceof Error ? error_2.message : String(error_2));
                    return [3 /*break*/, 5];
                case 4:
                    occupied.current = false;
                    if (mounted.current)
                        setBusy(false);
                    else {
                        (_a = engine.current) === null || _a === void 0 ? void 0 : _a.free();
                        engine.current = null;
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var readHistory = function (current_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([current_1], args_1, true), void 0, function (current, assigned, known) {
            var names, result, _a, _b, error_3;
            if (assigned === void 0) { assigned = boards; }
            if (known === void 0) { known = catalog.current; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!current)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        names = Array.from(new Set(__spreadArray(__spreadArray([], known, true), assigned.flatMap(function (board) {
                            return board.parent ? [board.name, board.parent] : [board.name];
                        }), true)));
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, current.sessionHistory(JSON.stringify(names))];
                    case 2:
                        result = _b.apply(_a, [_c.sent()]);
                        if (mounted.current) {
                            setHistory(result);
                            setHistoryError("");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _c.sent();
                        if (mounted.current) {
                            setHistory(null);
                            setHistoryError(error_3 instanceof Error ? error_3.message : String(error_3));
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var install = function (contents, backup) { return __awaiter(void 0, void 0, void 0, function () {
        var module, candidate, publicKeys, storageKey, saved, restored, _a, _b, _c, nextCatalog, error_4;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, loadBrowserTrustee()];
                case 1:
                    module = _e.sent();
                    if (!mounted.current)
                        return [2 /*return*/];
                    candidate = createBrowserTrustee(module, auth.trustee || "browser trustee", contents, boardUrl, accessToken);
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 7, , 8]);
                    publicKeys = JSON.parse(candidate.publicKeys());
                    storageKey = "sequent-wbraid-catalog:".concat(boardUrl.replace(/\/+$/, ""), ":").concat(publicKeys.signing_public_key);
                    saved = JSON.parse(localStorage.getItem(storageKey) || "[]");
                    if (!Array.isArray(saved) || !saved.every(function (name) { return typeof name === "string"; }))
                        throw new Error("Invalid local session catalogue.");
                    if (!backup) return [3 /*break*/, 4];
                    _c = (_b = JSON).parse;
                    return [4 /*yield*/, candidate.restoreBackup(backup)];
                case 3:
                    _a = _c.apply(_b, [_e.sent()]);
                    return [3 /*break*/, 5];
                case 4:
                    _a = [];
                    _e.label = 5;
                case 5:
                    restored = _a;
                    nextCatalog = Array.from(new Set(__spreadArray(__spreadArray([], saved, true), restored, true)));
                    localStorage.setItem(storageKey, JSON.stringify(nextCatalog));
                    (_d = engine.current) === null || _d === void 0 ? void 0 : _d.free();
                    engine.current = candidate;
                    privateKeys.current = contents;
                    catalog.current = nextCatalog;
                    catalogKey.current = storageKey;
                    setHistory(null);
                    setHistoryError("");
                    setKeys(publicKeys);
                    return [4 /*yield*/, readHistory(candidate, boards, nextCatalog)];
                case 6:
                    _e.sent();
                    setBrowserStatus("Keys ready. Register both public keys before starting a ceremony.");
                    return [3 /*break*/, 8];
                case 7:
                    error_4 = _e.sent();
                    candidate.free();
                    throw error_4;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var importKeys = function (file) {
        if (file)
            void perform(function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = install;
                            return [4 /*yield*/, file.text()];
                        case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
                        case 2:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
    };
    var importBackup = function (file) {
        if (file)
            void perform(function () { return __awaiter(void 0, void 0, void 0, function () {
                var contents, backup;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, file.text()];
                        case 1:
                            contents = _a.sent();
                            backup = JSON.parse(contents);
                            if (typeof backup !== "object" ||
                                backup === null ||
                                !("keys" in backup) ||
                                typeof backup.keys !== "string")
                                throw new Error("Invalid browser trustee backup.");
                            return [4 /*yield*/, install(backup.keys, contents)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
    };
    var cycle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!active.current || !engine.current || occupied.current)
                        return [2 /*return*/];
                    occupied.current = true;
                    setBusy(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 6]);
                    return [4 /*yield*/, runBrowserCycle(engine.current, platform, accessToken, function (assigned) {
                            catalog.current = Array.from(new Set(__spreadArray(__spreadArray([], catalog.current, true), assigned.flatMap(function (board) {
                                return board.parent ? [board.name, board.parent] : [board.name];
                            }), true)));
                            localStorage.setItem(catalogKey.current, JSON.stringify(catalog.current));
                        })];
                case 2:
                    result = _b.sent();
                    if (mounted.current) {
                        setBoards(result);
                        setLoaded(true);
                        if (active.current)
                            setBrowserStatus("Browser trustee running \u00B7 ".concat(result.length, " assigned boards. Keep this page open."));
                    }
                    return [3 /*break*/, 6];
                case 3:
                    error_5 = _b.sent();
                    active.current = false;
                    if (mounted.current) {
                        setRunning(false);
                        setBrowserStatus("Browser trustee stopped after an error. Resolve it before restarting.");
                        setError(error_5 instanceof Error ? error_5.message : String(error_5));
                    }
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, readHistory(engine.current)];
                case 5:
                    _b.sent();
                    occupied.current = false;
                    if (!active.current)
                        release();
                    if (mounted.current)
                        setBusy(false);
                    else {
                        (_a = engine.current) === null || _a === void 0 ? void 0 : _a.free();
                        engine.current = null;
                    }
                    return [7 /*endfinally*/];
                case 6:
                    if (active.current)
                        timer.current = setTimeout(function () {
                            void cycle();
                        }, 2000);
                    return [2 /*return*/];
            }
        });
    }); };
    var stop = function () {
        active.current = false;
        clearTimeout(timer.current);
        setRunning(false);
        if (!occupied.current)
            release();
        setBrowserStatus("Stopped. Local session commitments are retained for resuming.");
    };
    var start = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!keys || !engine.current || active.current || occupied.current)
                        return [2 /*return*/];
                    active.current = true;
                    setRunning(true);
                    setError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runExclusiveBrowserTrustee(catalogKey.current, function () { return __awaiter(void 0, void 0, void 0, function () {
                            var stopped;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!mounted.current || !active.current)
                                            return [2 /*return*/];
                                        stopped = new Promise(function (resolve) {
                                            releaseLock.current = resolve;
                                        });
                                        void cycle();
                                        return [4 /*yield*/, stopped];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    active.current = false;
                    if (mounted.current) {
                        setRunning(false);
                        setError(error_6 instanceof Error ? error_6.message : String(error_6));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var prove = function (file) {
        if (file)
            void perform(function () { return __awaiter(void 0, void 0, void 0, function () {
                var request, _a, _b, proof;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!engine.current)
                                throw new Error("Import your trustee keys first.");
                            _b = (_a = JSON).parse;
                            return [4 /*yield*/, file.text()];
                        case 1:
                            request = _b.apply(_a, [_c.sent()]);
                            if (!auth.trustee || request.trustee_name !== auth.trustee)
                                throw new Error("The custody file belongs to another trustee.");
                            if (tallyId.trim())
                                request.tally_session_id = tallyId.trim();
                            proof = engine.current.attest(JSON.stringify(request));
                            download("signed-custody-proof.json", proof, "application/json");
                            setBrowserStatus("Signed custody proof ready to upload to the key or tally ceremony.");
                            return [2 /*return*/];
                    }
                });
            }); });
    };
    return (_jsxs(Box, { sx: { p: { xs: 2, sm: 3 } }, children: [_jsx(Typography, { variant: "h4", component: "h1", children: "Trustee dashboard" }), _jsx(Typography, { sx: { my: 2 }, children: "Use the browser trustee below or run the native trustee tool with your local keys file. It discovers your assigned boards, verifies their messages and resumes from its local session stores." }), _jsx(Card, { sx: { mb: 2 }, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", component: "h2", children: "Browser trustee" }), _jsx(Typography, { sx: { my: 2 }, children: "Generate or import your local trustee keys. Your private keys stay in this browser's memory. Back up the keys file and browser sessions, and keep this page open while participating." }), _jsx(Typography, { sx: { my: 2 }, children: "For manual custody, start this browser trustee and keep this tab open. Upload the saved custody file in the key ceremony or tally tab; this browser creates the scoped proof automatically. Complete the custody confirmation and any required signing in that tab." }), _jsx(TextField, { label: "Board service URL", value: boardUrl, disabled: Boolean(keys) || busy, onChange: function (event) { return setBoardUrl(event.target.value); }, fullWidth: true, sx: { mb: 2 } }), _jsxs(Box, { sx: actionGrid, children: [_jsx(Button, { variant: "outlined", disabled: Boolean(keys) || busy, onClick: function () {
                                        void perform(function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var module;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, loadBrowserTrustee()];
                                                    case 1:
                                                        module = _a.sent();
                                                        return [4 /*yield*/, install(module.BrowserTrustee.generateKeys())];
                                                    case 2:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                    }, children: "Generate browser keys" }), _jsx(Button, { variant: "outlined", disabled: busy || running, onClick: function () { var _a; return (_a = keysInput.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "Import private keys" }), _jsx("input", { ref: keysInput, "aria-label": "Import private keys", type: "file", hidden: true, accept: ".toml", onChange: function (event) {
                                        var _a;
                                        importKeys((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]);
                                        event.target.value = "";
                                    } }), _jsx(Button, { variant: "outlined", disabled: busy || running, onClick: function () { var _a; return (_a = backupInput.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "Restore browser backup" }), _jsx("input", { ref: backupInput, "aria-label": "Restore browser backup", type: "file", hidden: true, accept: ".json", onChange: function (event) {
                                        var _a;
                                        importBackup((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]);
                                        event.target.value = "";
                                    } }), _jsx(Button, { variant: "outlined", disabled: !keys || busy, onClick: function () {
                                        return download("private-keys.toml", privateKeys.current, "text/plain");
                                    }, children: "Download private keys" }), _jsx(Button, { variant: "outlined", disabled: !keys || busy || running, onClick: function () {
                                        void perform(function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        if (!engine.current) return [3 /*break*/, 2];
                                                        _a = download;
                                                        _b = ["browser-sessions.json"];
                                                        return [4 /*yield*/, engine.current.backup(JSON.stringify(catalog.current))];
                                                    case 1:
                                                        _a.apply(void 0, _b.concat([_c.sent(), "application/json"]));
                                                        _c.label = 2;
                                                    case 2: return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                    }, children: "Back up browser sessions" }), _jsx(Button, { variant: "outlined", disabled: !keys || busy || running, onClick: function () {
                                        var _a;
                                        (_a = engine.current) === null || _a === void 0 ? void 0 : _a.free();
                                        engine.current = null;
                                        privateKeys.current = "";
                                        setKeys(null);
                                        setHistory(null);
                                        setHistoryError("");
                                        setBrowserStatus("");
                                    }, children: "Lock keys" })] }), keys && (_jsxs(Box, { sx: { my: 2 }, children: [_jsx(TextField, { label: "Signing public key", value: keys.signing_public_key, InputProps: { readOnly: true }, fullWidth: true, sx: { mb: 2 } }), _jsx(TextField, { label: "Share encryption public key", value: keys.share_encryption_public_key, InputProps: { readOnly: true }, fullWidth: true })] })), _jsxs(Box, { sx: __assign(__assign({}, actionGrid), { mt: 2 }), children: [_jsx(Button, { variant: "contained", disabled: !keys || busy || running || !auth.trustee, onClick: function () {
                                        void start();
                                    }, children: "Start browser trustee" }), _jsx(Button, { variant: "outlined", disabled: !running, onClick: stop, children: "Stop browser trustee" })] }), _jsx(Typography, { role: "status", sx: { my: 2 }, children: browserStatus }), _jsxs(Box, { component: "section", "aria-labelledby": "trustee-history-heading", sx: { my: 2 }, children: [_jsx(Typography, { id: "trustee-history-heading", variant: "h6", component: "h3", children: "Local session history" }), _jsx(Typography, { sx: { my: 1 }, children: "History is read from this browser using the loaded signing key and board service URL. These are the records the trustee reads when resuming a session. Counts confirm readable history, not a completed ceremony." }), _jsx(Button, { variant: "outlined", disabled: !keys || busy || running, onClick: function () {
                                        void perform(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                            return [2 /*return*/, readHistory(engine.current)];
                                        }); }); });
                                    }, sx: { minHeight: 44, my: 1 }, children: "Refresh local history" }), !keys && (_jsx(Typography, { children: "Import your private keys or restore a browser backup to inspect history." })), historyError && (_jsxs(Alert, { severity: "error", children: ["Unable to read local history: ", historyError] })), history && (_jsxs(_Fragment, { children: [_jsxs(Typography, { sx: { overflowWrap: "anywhere", my: 1 }, children: ["Browser: ", window.location.origin, " \u00B7 Board service:", " ", history.board_url] }), history.stores.length === 0 && (_jsx(Typography, { children: "No known sessions. Refresh boards to include assigned sessions." })), history.stores.length > 0 && (_jsxs(Accordion, { disableGutters: true, sx: { mt: 2 }, slotProps: { transition: { unmountOnExit: true } }, children: [_jsx(AccordionSummary, { id: "trustee-history-entries-heading", "aria-controls": "trustee-history-entries-content", expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsxs(Typography, { component: "span", children: ["Session entries (", history.stores.length, ")"] }) }), _jsx(AccordionDetails, { children: history.stores.map(function (store) { return (_jsxs(Box, { sx: {
                                                            border: "1px solid",
                                                            borderColor: "divider",
                                                            borderRadius: 1,
                                                            p: 2,
                                                            my: 1,
                                                            overflowWrap: "anywhere",
                                                        }, children: [_jsx(Typography, { children: store.board }), _jsxs(Typography, { children: [store.predicates === 0
                                                                        ? "Empty history"
                                                                        : "History available", " ", "\u00B7 ", store.predicates, " records \u00B7", " ", store.own_posts, " own posts"] }), store.predicates === 0 &&
                                                                boards.some(function (board) { return board.parent === store.board; }) && (_jsx(Alert, { severity: "warning", sx: { my: 1 }, children: "Parent DKG history is empty. Restore the session backup for this identity before tallying. Imported elections may use history under the original DKG board." })), _jsx(Typography, { variant: "body2", children: store.database })] }, store.board)); }) })] }))] }))] }), _jsxs(Accordion, { disableGutters: true, sx: { mt: 2 }, slotProps: { transition: { unmountOnExit: true } }, children: [_jsx(AccordionSummary, { id: "browser-trustee-advanced-heading", "aria-controls": "browser-trustee-advanced-content", expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsx(Typography, { component: "h3", children: "Advanced" }) }), _jsxs(AccordionDetails, { children: [_jsx(Typography, { sx: { mb: 2 }, children: "A running browser trustee generates signed custody proofs automatically when you upload the saved custody file in the ceremony or tally wizard. Use this option only when you need to create and upload a proof file yourself. Stop the browser trustee before generating a file." }), _jsx(TextField, { label: "Tally session ID", helperText: "For a tally proof, copy the tally ID from the tally wizard. Leave blank for key-ceremony custody.", value: tallyId, disabled: busy || running, onChange: function (event) { return setTallyId(event.target.value); }, fullWidth: true, sx: { mb: 2 } }), _jsx(Box, { sx: actionGrid, children: _jsx(Button, { variant: "outlined", disabled: !keys || busy || running, onClick: function () { var _a; return (_a = custodyInput.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "Generate signed custody proof manually" }) }), _jsx("input", { ref: custodyInput, "aria-label": "Custody file", type: "file", hidden: true, accept: ".json", onChange: function (event) {
                                                var _a;
                                                prove((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]);
                                                event.target.value = "";
                                            } })] })] })] }) }), _jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", component: "h2", children: "Local trustee tool" }), _jsx(Box, { component: "pre", sx: codeExample, children: _jsx("code", { children: "trustee generate --trustee-config ".concat(keysFilename, "\ntrustee start --trustee-config ").concat(keysFilename) }) }), _jsxs(Typography, { children: ["Register both public keys printed by generate. Keep a private backup of", " ", keysFilename, " and the message_store directory."] }), _jsx(Typography, { sx: { mt: 2 }, children: "For a manual ceremony, download its custody file and create a signed custody proof to upload to the portal:" }), _jsx(Box, { component: "pre", sx: codeExample, children: _jsx("code", { children: "trustee attest --request ".concat(requestFilename, " --trustee-config ").concat(keysFilename, " --output ").concat(proofFilename) }) }), _jsx(Typography, { children: "For a tally restore, add --tally-session-id with the tally session's ID. The proof contains a signature and public metadata." })] }) }), _jsxs(Typography, { variant: "h6", component: "h2", sx: { mt: 3 }, children: ["Boards assigned to ", auth.trustee || "your trustee"] }), _jsxs(Box, { sx: {
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "minmax(0, 1fr) auto" },
                    alignItems: "center",
                    gap: 2,
                    my: 2,
                }, children: [_jsx(TextField, { label: "Platform URL", value: platform, InputProps: { readOnly: true }, fullWidth: true }), _jsx(Button, { variant: "outlined", onClick: refresh, disabled: loading, sx: { minHeight: 44 }, children: loading ? "Loading boards…" : "Refresh boards" })] }), error && _jsx(Alert, { severity: "error", children: error }), loaded && boards.length === 0 && (_jsx(Typography, { children: "No boards are currently assigned." })), boards.map(function (board) { return (_jsx(Card, { sx: { my: 1 }, children: _jsxs(CardContent, { children: [_jsx(Typography, { sx: { overflowWrap: "anywhere" }, children: board.name }), _jsxs(Typography, { children: [board.kind, board.parent ? " \u00B7 Parent: ".concat(board.parent) : ""] })] }) }, board.name)); })] }));
};
